export default "__VITE_ASSET__0h80Mo0F__"